/** @jsxImportSource @emotion/react */
import { Icon } from "@coreai/component-library";
import { css, useTheme } from "@emotion/react";
import React from "react";
import { NavLink } from "react-router-dom";
import link from '../../../assets/link.svg';

interface ToolBarBoxProps {
  title: string;
  iconName: string;
  isActive?: boolean;
  path: string;
  onClick?: () => void;
}

const ToolBarBox: React.FC<ToolBarBoxProps> = ({
  title,
  iconName = "folder",
  isActive = false,
  path = "/",
  onClick,
}) => {
  const theme = useTheme();

  const containerStyles = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 18px 12px;
    gap: 6px;
    background-color: ${isActive ? theme.colors.secondary : "transparent"};
    color: ${isActive ? theme.colors.white : theme.colors.textDark};
    cursor: pointer;
    text-decoration: none;
    transition: background-color 0.3s ease, color 0.3s ease;
    font-family: ${theme.typography.bodyMedium.fontFamily};

    &:hover {
      background-color: ${isActive
        ? theme.colors.primary
        : theme.colors.secondary};
      color: ${theme.colors.white};
    }

    @media (max-width: 1280px) {
      padding: 15px 0;
    }

    @media (max-width: 768px) {
      justify-content: flex-start;
      ${path !== "/about" ? `width: 20%;` : ""}
    }
  `;

  const textStyles = css`
    font-family: ${theme.typography.bodyMedium.fontFamily};
    font-size: ${theme.typography.bodyMedium.fontSize};
    font-weight: ${theme.typography.bodyMedium.fontWeight};
    line-height: 16px;
    text-align: center;
    color: inherit;

    @media (max-width: 1280px) {
      font-size: 14px;
    }
  `;

  const iconStyles = css`
    color: inherit;
    margin: 4px;
    width: 24px;
    height: 24px;

    @media (max-width: 1280px) {
      margin: 2px;
    }
  `;

  return (
    <>
      {path === "/more" ? (
        <div
          className="nav-item"
          css={containerStyles}
          role="button"
          onClick={(e) => {
            e.preventDefault();
            onClick?.();
          }}
        >
          <Icon css={iconStyles} size="md" name={iconName} />
          <span css={textStyles}>{title}</span>
        </div>
      ) : (
        <NavLink
          className="nav-item"
          css={containerStyles}
          to={path}
          style={{ textDecoration: "none" }}
          role="link"
          onClick={(e) => onClick?.()}
        >
          <Icon css={iconStyles} size="md" name={iconName} />
          <span css={textStyles}>{title}</span>
        </NavLink>
      )}
    </>
  );
};

export default ToolBarBox;
